import { Box, Divider, Stack, TextField, Typography, useTheme } from "@mui/material";
import { useGetPlanActionItems, type GetPlanActionItemDto } from "src/http";
import { Autocomplete } from "../Autocomplete";
import { AutocompleteOption } from "../AutocompleteOption";

interface Props {
  teamSlug: string | undefined;
  disabled?: boolean;
  onChange: (actionItem: GetPlanActionItemDto | null) => void;
}

const StrategicItemPicker = (props: Props) => {
  const { data, isFetching } = useGetPlanActionItems(props.teamSlug);
  const theme = useTheme();

  function sortFunction(a: GetPlanActionItemDto, b: GetPlanActionItemDto) {
    return a.sectionName.localeCompare(b.sectionName) || a.description.localeCompare(b.description);
  }

  return (
    <Autocomplete
      isLoading={isFetching}
      disabled={!props.teamSlug || props.disabled || isFetching}
      options={data ? [...data.actionItems].sort(sortFunction) : []}
      getOptionLabel={(option) => option.description}
      renderOption={(props, option) => (
        <AutocompleteOption {...props} key={option.actionItemGuid}>
          <Typography>{option.description}</Typography>
        </AutocompleteOption>
      )}
      isOptionEqualToValue={(option, value) => option.actionItemGuid === value.actionItemGuid}
      groupBy={(option) => option.sectionName}
      renderGroup={(group) => (
        <Box key={group.key} sx={{ pb: 0.25 }}>
          <Stack
            spacing={0.2}
            sx={{
              px: 0.5,
              pt: 0.75,
              position: "sticky",
              top: 0,
              backgroundColor: theme.palette.common.white,
              zIndex: 2,
            }}
          >
            <Typography variant="caption">{group.group.toLocaleUpperCase()}</Typography>
            <Divider />
          </Stack>
          {group.children}
        </Box>
      )}
      renderInput={(params) => <TextField {...params} placeholder="Select a strategic map item..." />}
      onChange={(_, value) => props.onChange(value)}
    />
  );
};

export { StrategicItemPicker };
